import { render, staticRenderFns } from "./OImage.vue?vue&type=template&id=79c93de4&scoped=true&"
import script from "./OImage.vue?vue&type=script&lang=js&"
export * from "./OImage.vue?vue&type=script&lang=js&"
import style0 from "./OImage.vue?vue&type=style&index=0&id=79c93de4&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c93de4",
  null
  
)

export default component.exports